'use client'

import { Cell, Text, Icon } from '@vinted/web-ui'
import { CancelCircleFilled24 } from '@vinted/monochrome-icons'

type Props = {
  title: string
  body: string
}

const ErrorBanner = ({ title, body }: Props) => {
  return (
    <Cell
      theme="warning"
      prefix={
        <Icon
          name={CancelCircleFilled24}
          color={Icon.Color.GreyscaleLevel6}
          aria={{ 'aria-hidden': 'true' }}
        />
      }
      title={<Text as="h2" text={title} theme="inverse" type={Text.Type.Title} />}
      body={<Text as="span" text={body} theme="inverse" type={Text.Type.Body} />}
    />
  )
}

export default ErrorBanner
